import { render, staticRenderFns } from "./floor-coupon.vue?vue&type=template&id=b150aed0&scoped=true"
import script from "./floor-coupon.vue?vue&type=script&lang=js"
export * from "./floor-coupon.vue?vue&type=script&lang=js"
import style0 from "./floor-coupon.vue?vue&type=style&index=0&id=b150aed0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b150aed0",
  null
  
)

export default component.exports